import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import LazyLoad from 'react-lazyload';

import BaseCard from '../shared/BaseCard';
import Avatar from '../shared/Avatar';
import Title from '../shared/Title';
import { breakpoints, palette } from '../../constants/styles';

const StyledBaseCard = styled(BaseCard)`
  display: flex;
  align-items: center;
  margin: 25px 0;

  &:first-child {
    margin-top: 0;
  }

  ${breakpoints.tabletLandscape} {
    margin: 0px 0px 50px 0px;
    max-width: 375px;
  }
`;

const Description = styled.span`
  color: ${palette.textColor};
`;

const Content = styled.div``;

const avatarStyles = css`
  flex-shrink: 0;
  margin-right: 10px;
  border: 1px solid #E9E9E9;

`;
// (TODO) - BRING BACK STYLES THAT HECTOR CREATED TO QUICKRESOURCECARD DESKTOP
const QuickResourceCard = ({ image, title, description, link }) => (
  <a href={link} style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
    <StyledBaseCard noBorder>
      <LazyLoad height={55} offset={1200}>
        <Avatar src={image} size={55} styles={avatarStyles} />
      </LazyLoad>
      <Content>
        <Title level={6}>{title}</Title>
        <Description>{description}</Description>
      </Content>
    </StyledBaseCard>
  </a>
);

QuickResourceCard.propTypes = {
  link: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

QuickResourceCard.defaultProps = {
  link: '',
  image: '',
  title: 'Lorem ipsum',
  description: 'lorem ipsum dolor sit ammet consequitur',
};

export default QuickResourceCard;
